type Listener<T = unknown> = (data: T) => void;

/**
 * Typed publish/subscribe event bus. This is the ONLY way modules
 * communicate with siblings. No direct references between modules.
 *
 * Uses arrays instead of Sets to avoid iterator allocation on emit().
 */
export class EventBus {
  private _listeners = new Map<string, Listener[]>();

  on<T = unknown>(event: string, listener: Listener<T>): void {
    let arr = this._listeners.get(event);
    if (!arr) {
      arr = [];
      this._listeners.set(event, arr);
    }
    arr.push(listener as Listener);
  }

  off<T = unknown>(event: string, listener: Listener<T>): void {
    const arr = this._listeners.get(event);
    if (!arr) return;
    const idx = arr.indexOf(listener as Listener);
    if (idx >= 0) arr.splice(idx, 1);
  }

  emit<T = unknown>(event: string, data: T): void {
    const arr = this._listeners.get(event);
    if (!arr) return;
    for (let i = 0; i < arr.length; i++) {
      arr[i](data);
    }
  }

  clear(): void {
    this._listeners.clear();
  }
}
